<template>
  <div class="cemsPreAlarm" ref="cemsPreAlarm">
    <div class="bg_box">
      <div class="allCount" @click="rowClick('ALL')">
        <p class="boldNumber">{{getAllSum}}</p>
        <span>总预警</span>
      </div>
      <ul>
        <li><span>预测时段</span><span>{{dataList.rangStartTime+'-'+dataList.rangEndTime}}</span></li>
        <li @click="rowClick('SO2')"><span>SO2超标预警</span><span class="number">{{getValue(17)}}</span></li>
        <li @click="rowClick('NOX')"><span>NOX超标预警</span><span class="number">{{getValue(18)}}</span></li>
        <li @click="rowClick('KLW')"><span>颗粒物超标预警</span><span class="number">{{getValue(19)}}</span></li>
      </ul>
    </div>

  </div>
</template>

<script>
import cemsPreAlarmDialog from "./components/cemsPreAlarmDialog";

import { mapGetters } from "vuex";
export default {
  props: ["matrix", "x", "y"],
  components: {
    cemsPreAlarmDialog,
  },
  data() {
    return {
      pageInfo: 'cemsPreAlarm.vue',
      computedName: 'cems设备超标预测组件',
      customerId: this.$store.state.customerId,
      setTime1: null,
      dataList: {},
    };
  },
  computed: {
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
    getValue() {
      return (i) => {
        let arr = this.dataList?.cemsPredictionInfoList || [];
        return arr.find((item) => i == item.categoryId)?.times;
      };
    },
    getAllSum() {
      return (
        (this.getValue(17) || 0) +
        (this.getValue(18) || 0) +
        (this.getValue(19) || 0)
      );
    },
  },

  created() {},

  mounted() {
    let that = this;
    let w = $(that.$refs.cemsPreAlarm).outerWidth();
    let h = $(that.$refs.cemsPreAlarm).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.getListData();
  },
  unmounted() {
    if (this.setTime1) {
      clearTimeout(this.setTime1);
      this.setTime1 = null;
    }
  },
  methods: {
    rowClick(e) {
      console.log("点解", e);
      this.$store.commit("dialogStatus", true);
      this.$popup.open(cemsPreAlarmDialog, this.dialogCompontent, this, {
        preType: e,
      });
    },
    async getListData() {
      if (this.setTime1) {
        clearTimeout(this.setTime1);
        this.setTime1 = null;
      }
      try {
        const cemsPredictionAssembly =
          CONFIG.requestName + this.$apiOpt.cemsPredictionAssembly;
        let res = await this.$apiUtils.get(cemsPredictionAssembly, {
          customerId: this.customerId,
        });

        this.dataList = res;
        console.log("this.dataList", this.dataList);
      } catch (err) {
        console.log(err);
      }
      this.setTime1 = setTimeout(() => {
        this.getListData();
      }, 60 * 1000);
    },
  },
};
</script>
<style lang="scss">
.cemsPreAlarm {
  height: 250px;
  width: 100%;
  pointer-events: all;
  padding-top: 55px !important;
  .bg_box {
    display: flex;
    @include bg-box(100%, 100%, "bg.png");
    .allCount {
      width: 270px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      cursor: pointer;
      p {
        font-size: 38px;
        font-weight: bold;
        color: #c1fdff;
      }
      span: {
        font-size: 12px;
      }
    }
    & > ul {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      li {
        display: flex;
        cursor: pointer;
        justify-content: space-around;
        align-items: center;
        @include bg-box(100%, 100%, "libg.png");
        &:nth-of-type(1) {
          background: none;
          span {
            color: #fff !important;
            &:nth-of-type(2) {
              font-size: 18px;
            }
          }
        }
        span {
          display: block;
          width: 50%;
          // text-align: center;
          font-size: 22px;
          font-weight: 400;
          margin-left: 10px;
          color: #fffcc7;
          &:nth-of-type(1) {
            font-size: 18px;
            font-weight: 500;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
